export default {
  productName: 'Jina la bidhaa',
  pay: 'LIPA',
  payTokenLack: 'Tokeni ya malipo inahitajika! Tafadhali wasiliana nasi kwa msaada zaidi',
  payTokenInvalid: 'Tokeni ya malipo na chaneli haziendani',
  noPayChannel: 'Hakuna kituo cha malipo kinachopatikana',
  currencyMismatch: 'Huwezi kuendelea, tafadhali jaribu chaneli nyingine au wasiliana nasi',
  networkError: 'Seva ya wavuti haipatikani ,tafadhali jaribu baadae',
  invokeTimeoutNotice: 'Matokeo ya malipo bado yako njiani ... Tafadhali angalia hali yako ya kuagiza na ujaribu tena baadaye.',
  ok: 'SAWA',
  paymentMethodNotSupported: 'Njia hii ya malipo haikubaliki, tafadhali jaribu njia nyingine',
  enterCompleteInfo: 'Tafadhali weka taarifa sahihi',
  enterCorrectInfo: 'Tafadhali weka XXX sahihi',
  sendOtpCode: 'TUMA',
  textOnairNext: 'ENDELEA',
  voteCancel: 'SITISHA',
  paymentSuccessful: 'Lipia Tayari',
  paymentSuccessfulDesc: 'Akhsante kwa malipo. Ombi lako limefanikiwa. Tafadhali bonyeza ‘OK’ kama bado haijaelekezwa ndani ya sekunde 10',
  paymentFailed: 'Malipo hayajafanikiwa',
  refresh: 'Rudia',
  orderIdEmpty: 'Kitambulisho cha Ombi ni kitupu, ombi batili. Tafadhali wasiliana nasi kwa msaada zaidi',
  waitingMessage: 'Tunashughulikia maombi yako, tafadhali subiri kidogo',
  resultTimeoutNotice: 'Muda wa malipo umepita, bado tunaendelea kushughulikia malipo yako na inaweza kuchukua muda. Majibu yatakuja, akhsante kwa kuvuta subira.'
}
